import { OnboardingPage } from "../common/layout";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import Spinner from "../../components/ui/spinner";
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useOrgController } from "../../auth/org-provider";
import React from "react";
import { config } from "../../lib/config";
import { useCreateOrgMutation } from "../../data/mutations/create-org";

export default function CreateOrgPage() {
    const orgController = useOrgController();
    const [orgName, setOrgName] = useState<string>("");
    const navigate = useNavigate();
    const createOrgMutation = useCreateOrgMutation({
        onSuccess: () => {
            navigate("/organization-setup");
        },
    });
    function createOrg() {
        createOrgMutation.mutate({ orgName });
    }

    useEffect(() => {
        document.title = "Create Organization - Tekkr";
    });

    if (orgController.org && config.env === "prod") {
        return <Navigate to={{ pathname: "/" }} replace />;
    }

    return (
        <OnboardingPage>
            <div className={"flex w-full flex-col gap-2"}>
                <h1 className={"w-full text-start"}>Create a new organization</h1>
                <p className={"my-4"}>
                    Organizations are shared environments where teams can discover and edit new Playbooks, and access
                    implemented ones. Let's get started.
                </p>
                {!createOrgMutation.isPending ? (
                    <>
                        <div className="my-2 grid w-full max-w-sm items-center gap-1.5">
                            <Label htmlFor={"org-name-input"}>Organization Name</Label>
                            <Input
                                className={"w-full"}
                                value={orgName}
                                onChange={(v) => setOrgName(v.target.value)}
                                id={"org-name-input"}
                                placeholder={"Acme Corporation"}
                            ></Input>
                        </div>
                        <Button onClick={createOrg}>Create organization</Button>
                    </>
                ) : (
                    <div className={"flex flex-row items-center justify-center gap-3"}>
                        <Spinner className={""} />
                        <p className={"text-sm font-semibold"}>Creating your organization...</p>
                    </div>
                )}
                <hr className={"my-4"} />
                <h4>Is your company already using Tekkr?</h4>
                <p className={"mt-2"}>
                    Ask for an invite to join your company's existing organization. Or{" "}
                    <a href={"https://www.tekkr.io/contact-us"} className={"underline"}>
                        contact us
                    </a>{" "}
                    if you need help.
                </p>
            </div>
        </OnboardingPage>
    );
}
